import * as dayjs from "dayjs";
const dateFormat = (value, format) => {
  if (format == "human") {
    format = "MMM D, YYYY [at] h:mm a";
  }
  return dayjs(value).format(format);
};
export default dateFormat;
